var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconExternalBankTransfersColoured = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28860_94307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8734 15.5041C24.7568 15.5041 24.6388 15.4634 24.5441 15.3801C23.2821 14.2734 21.6681 13.6641 20.0001 13.6641C18.4281 13.6641 16.8908 14.2154 15.6708 15.2174C15.4568 15.3927 15.1414 15.3614 14.9668 15.1481C14.7921 14.9347 14.8228 14.6194 15.0361 14.4441C16.4341 13.2961 18.1974 12.6641 20.0001 12.6641C21.9108 12.6641 23.7588 13.3614 25.2034 14.6281C25.4108 14.8101 25.4314 15.1261 25.2494 15.3341C25.1508 15.4461 25.0121 15.5041 24.8734 15.5041Z",
    fill: "#5D9AC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8329 15.3308H15.1663C14.8903 15.3308 14.6663 15.1068 14.6663 14.8308V13.1641C14.6663 12.9621 14.7883 12.7794 14.9749 12.7021C15.1616 12.6248 15.3769 12.6674 15.5196 12.8108L17.1863 14.4774C17.3289 14.6201 17.3723 14.8354 17.2949 15.0221C17.2176 15.2088 17.0349 15.3308 16.8329 15.3308Z",
    fill: "#5D9AC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0802 27.3362C18.1688 27.3362 16.3208 26.6388 14.8768 25.3722C14.6688 25.1902 14.6488 24.8742 14.8308 24.6662C15.0128 24.4588 15.3288 24.4382 15.5368 24.6202C16.7982 25.7268 18.4115 26.3362 20.0802 26.3362C21.6522 26.3362 23.1895 25.7848 24.4095 24.7828C24.6228 24.6068 24.9375 24.6382 25.1135 24.8522C25.2888 25.0655 25.2575 25.3808 25.0442 25.5562C23.6462 26.7042 21.8828 27.3362 20.0802 27.3362Z",
    fill: "#5D9AC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8333 27.3307C24.7033 27.3307 24.5753 27.2801 24.48 27.1841L22.8133 25.5174C22.6707 25.3747 22.6273 25.1594 22.7047 24.9727C22.782 24.7861 22.9647 24.6641 23.1667 24.6641H24.8333C25.1093 24.6641 25.3333 24.8881 25.3333 25.1641V26.8307C25.3333 27.0327 25.2113 27.2154 25.0247 27.2927C24.9627 27.3181 24.898 27.3307 24.8333 27.3307Z",
    fill: "#5D9AC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7714 19.0709L17.8955 19.0709C18.1869 19.0709 18.3014 18.6848 18.0589 18.5196L15.6603 16.8862C15.4624 16.7515 15.2046 16.7515 15.0067 16.8862L12.608 18.5196C12.3655 18.6848 12.48 19.0709 12.7714 19.0709Z",
    fill: "#5D9AC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4763 19.4994H14.3335V20.928H13.4763V19.4994Z",
    fill: "#5D9AC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1906 19.4994H16.3335V20.928H17.1906V19.4994Z",
    fill: "#5D9AC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9049 19.4994H15.762V20.928H14.9049V19.4994Z",
    fill: "#5D9AC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6981 21.5145C17.6497 21.4177 17.5508 21.3566 17.4426 21.3566L13.2243 21.3566C13.1161 21.3566 13.0172 21.4177 12.9688 21.5145L12.6831 22.086C12.5881 22.2759 12.7262 22.4994 12.9386 22.4994H17.7283C17.9407 22.4994 18.0788 22.2759 17.9839 22.086L17.6981 21.5145Z",
    fill: "#5D9AC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1049 19.0709L27.229 19.0709C27.5204 19.0709 27.6349 18.6848 27.3924 18.5196L24.9938 16.8862C24.7959 16.7515 24.538 16.7515 24.3402 16.8862L21.9415 18.5196C21.699 18.6848 21.8135 19.0709 22.1049 19.0709Z",
    fill: "#5D9AC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8098 19.4994H23.667V20.928H22.8098V19.4994Z",
    fill: "#5D9AC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5241 19.4994H25.667V20.928H26.5241V19.4994Z",
    fill: "#5D9AC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2384 19.4994H25.0955V20.928H24.2384V19.4994Z",
    fill: "#5D9AC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0316 21.5145C26.9832 21.4177 26.8843 21.3566 26.7761 21.3566L22.5578 21.3566C22.4496 21.3566 22.3507 21.4177 22.3023 21.5145L22.0166 22.086C21.9216 22.2759 22.0597 22.4994 22.2721 22.4994H27.0618C27.2742 22.4994 27.4123 22.2759 27.3174 22.086L27.0316 21.5145Z",
    fill: "#5D9AC6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28860_94307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(12 12)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconExternalBankTransfersColoured);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_external_bank_transfers_coloured.0521b7e579fc4aefc9f70350dc21cc0e.svg";